import { Box, BoxBasedComponentProps } from '../Box';

export type DrawerBodyProps = BoxBasedComponentProps;

export const DrawerBody = (props: DrawerBodyProps) => (
  <Box position="relative" overflowY="auto" {...props} />
);
